import { HiddenAreaWidgetServerModelHelper, } from './HiddenAreaServerModel';
import { WidgetHelper } from '../content/contentBuilder/widgets/Widget';
import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
export const HiddenAreaConverter = {
    convertToDomainModel: (widget) => {
        var _a, _b;
        const properties = {
            isRequired: (_a = widget.properties.isRequired) !== null && _a !== void 0 ? _a : false,
            displayDelayInSeconds: (_b = widget.properties.displayDelayInSeconds) !== null && _b !== void 0 ? _b : 0,
        };
        return WidgetHelper.buildWidget(widget.id, widget.trackingIdentifier, {
            questionText: widget.data.questionText,
            locations: HiddenAreaConverter.convertToDomainAreaData(widget.data.locations),
        }, properties, WidgetType.hiddenArea);
    },
    convertToServerModel: (widget) => HiddenAreaWidgetServerModelHelper.create(widget._id, widget.trackingIdentifier, widget.value.data.questionText, widget.value.data.locations, widget.value.properties),
    convertToDomainAreaData: (locations) => locations.map((serverAreaData) => {
        const arrows = Array.isArray(serverAreaData.location) ? serverAreaData.location : [serverAreaData.location];
        const areaData = {
            ...serverAreaData,
            location: arrows,
        };
        return areaData;
    }),
};
